module.exports = __webpack_public_path__ + "img/ENG-img-08.e048ac25.jpg";